// @flow
import * as React from 'react';

import styles from '../styles/Buttons.scss';
import Modal from './Modal.jsx';
import { PrimaryText, Error } from './Typography.jsx';

type Props = {
  children?: React.Node,
  onClick?: Function,
}

export class Button extends React.Component<Props> {
  render() {
    return (
      <span className={styles.button} onClick={this.props.onClick}>
        {this.props.children}
      </span>
    );
  }
}

export class PrimaryButton extends React.Component<Props> {
  render() {
    return (
      <span className={styles.primaryButton} onClick={this.props.onClick}>
        {this.props.children}
      </span>
    );
  }
}

type DeleteButtonProps = {
  ...Props,
  // Used for archive button (change some text)
  archive?: boolean,
  modalText?: string,
}

type DeleteButtonState = {
  isOpen: boolean,
}

export class DeleteButton extends React.Component<DeleteButtonProps, DeleteButtonState> {
  constructor(props: DeleteButtonProps) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  openModal = () => {
    this.setState({
      isOpen: true,
    });
  }

  closeModal = () => {
    this.setState({
      isOpen: false,
    });
  }

  onDelete = () => {
    this.closeModal();
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    const modalText = typeof this.props.modalText === 'string' ? this.props.modalText : '';
    const headerText = `Confirm ${this.props.archive ? 'archive' : 'delete'} item?`;
    return (
      <span>
        <span className={styles.deleteButton} onClick={this.openModal}>
          {this.props.children}
        </span>
        <Modal isOpen={this.state.isOpen}>
          <div className={styles.deleteModal}>
            <div className={styles.deleteHeader}>
              <PrimaryText>{headerText}</PrimaryText>
              <div><strong><Error>{modalText}</Error></strong></div>
            </div>
            <span className={styles.deleteButton} onClick={this.onDelete}>
              {this.props.archive ? 'Archive' : 'Delete'}
            </span>
            <Button onClick={this.closeModal}>Cancel</Button>
          </div>
        </Modal>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./client/src/components/Buttons.jsx